import useCurrentLocationButton from '../../hooks/useCurrentLocationButton';

type CurrentLocationButtonAndMarkerProps = {
  onClick?: () => void;
};

/**
 * @deprecated Use useCurrentLocationButton instead
 */
const CurrentLocationButtonAndMarker = ({ onClick }: CurrentLocationButtonAndMarkerProps) => {
  const { currentLocationMarker, currentLocationButton, currentLocationModal } = useCurrentLocationButton(onClick);

  return (
    <>
      {currentLocationMarker}
      {currentLocationButton}
      {currentLocationModal}
    </>
  );
};

export default CurrentLocationButtonAndMarker;
